import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const ResultPublication = lazy(() => import('../../container/result-publication'));

const ResultPublicationRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/result-publication`} component={ResultPublication}/>
        </Switch>
    );
};

export default ResultPublicationRoutes;
